/* ==========================================================================
   etêrnea · Diseños de Autor
   --------------------------------------------------------------------------
   Solo se carga en templates/collection.disenos.json y
   templates/product.diseno.json.

   Hace dos cosas, y ninguna es decorativa:

   1) LA BISAGRA. Marca la foto sobre la que se hizo clic para que el
      navegador la lleve de la retícula a la ficha. Es el único momento del
      sistema con movimiento real: el producto flota en el vacío hasta el
      clic, y ahí se vuelve editorial.

   2) LA BARRA PEGAJOSA de móvil. Aparece cuando el bloque de compra sale de
      pantalla, y espeja el precio que el propio tema está mostrando — así
      nunca se desincroniza al cambiar de material.

   ⚠️ NO toca el carrito ni la mecánica de reservar. El CTA hace scroll
   hasta el bloque de Sesami; no lo pulsa. El <script> que desactiva
   «Agregar al carrito» hasta que Sesami carga vive aparte, dentro de la
   plantilla, tal cual estaba.
   ========================================================================== */

(function () {
  'use strict';

  var HERO = 'dsn-hero';
  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var supportsVT = typeof document.startViewTransition === 'function';

  /* ---------------------------------------------------------------- 1 · bisagra */

  function marcarHeroDeFicha() {
    var media = document.querySelector('.feature-product-media');
    if (!media) return;
    var img = media.querySelector('img');
    if (img) img.style.viewTransitionName = HERO;
  }

  function armarBisagraEnGaleria() {
    document.addEventListener(
      'click',
      function (event) {
        var enlace = event.target.closest && event.target.closest('a.product-image');
        if (!enlace) return;

        var img = enlace.querySelector('.product__img') || enlace.querySelector('img');
        if (!img) return;

        // Solo una foto puede llevar el nombre a la vez.
        document.querySelectorAll('[style*="' + HERO + '"]').forEach(function (previa) {
          previa.style.viewTransitionName = '';
        });
        img.style.viewTransitionName = HERO;

        // Si el usuario vuelve atrás (bfcache) la marca sobra.
        window.addEventListener(
          'pageshow',
          function () {
            img.style.viewTransitionName = '';
          },
          { once: true }
        );
      },
      true
    );
  }

  /* --------------------------------------------------------- 2 · barra pegajosa */

  function armarBarra() {
    var barra = document.querySelector('[data-dsn-sticky]');
    if (!barra) return;

    // El bloque de Sesami primero; si no está, el formulario de compra.
    var destino =
      document.querySelector('.product__info-wrapper .shopify-app-block') ||
      document.querySelector('.product__info-wrapper form[action*="/cart/add"]') ||
      document.querySelector('.product__info-wrapper');

    // El tema le pone id="price-<id de la sección>" al bloque de precio, así que
    // el anzuelo es exacto y no depende de clases sueltas.
    var bloquePrecio = document.querySelector('.product__info-wrapper [id^="price-"]');
    var precioTema = bloquePrecio && bloquePrecio.querySelector('.price');
    var precioBarra = barra.querySelector('[data-dsn-price]');

    // El precio de la barra es un espejo del que pinta el tema. Si el
    // selector de material lo cambia, aquí cambia solo.
    function espejarPrecio() {
      if (!precioTema || !precioBarra) return;
      var texto = (precioTema.textContent || '').replace(/\s+/g, ' ').trim();
      if (texto) precioBarra.textContent = texto;
    }

    if (precioTema && precioBarra && window.MutationObserver) {
      espejarPrecio();
      new MutationObserver(espejarPrecio).observe(precioTema, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    // La barra existe para cuando el bloque de compra ya no se ve.
    if (destino && window.IntersectionObserver) {
      new IntersectionObserver(
        function (entradas) {
          barra.classList.toggle('is-visible', !entradas[0].isIntersecting);
        },
        { rootMargin: '0px 0px -40% 0px' }
      ).observe(destino);
    } else {
      barra.classList.add('is-visible');
    }

    var cta = barra.querySelector('[data-dsn-cta]');
    if (cta && destino) {
      cta.addEventListener('click', function () {
        destino.scrollIntoView({
          behavior: reduced ? 'auto' : 'smooth',
          block: 'center'
        });
      });
    }
  }


  /* --------------------------------------------- la guardia del hueco de reserva

     🔴 POR QUÉ EXISTE, Y POR QUÉ YA NO NOMBRA A NINGUNA APP.
     Antes esperaba el evento `sesami:loaded`. Sesami está desinstalada desde
     hace meses, así que ese evento no iba a llegar NUNCA y el botón quedaba
     muerto para siempre, sin manera de revivirlo.

     La condición correcta no es «¿avisó tal app?» sino «¿hay un bloque de
     reserva en esta sección?». Con eso, el día que entre el de Astellor RSVP
     los botones se encienden solos y no hay que tocar una línea.

     🔑 Y la regla de fondo se conserva: una clienta que agrega un diseño al
     carrito sin elegir hora produce una cita imposible de cumplir. El botón
     apagado es el fallo seguro; el botón vivo sin hora es el peligroso.
     ------------------------------------------------------------------------- */

  var BOTONES = [
    'form[action*="/cart/add"] [type="submit"]',
    'button[name="add"]',
    '.product-form__submit',
    '.product-form button[type="submit"]'
  ].join(',');

  /* Cualquier bloque de app dentro de la columna de información del producto.
     ⚠️ Se acota a esa columna a propósito: el widget de reseñas también es un
     `.shopify-app-block` y, sin acotar, lo daría por bueno y encendería el
     botón sin que exista reserva. */
  var RESERVA = '[data-astellor-reserva], .shopify-app-block';
  var COLUMNA = '.product__info-wrapper, .product__info-container, .product-information';

  function hayReserva() {
    var col = document.querySelector(COLUMNA);
    return !!(col && col.querySelector(RESERVA));
  }

  function aplicarGuardia() {
    var puede = hayReserva();
    document.documentElement.classList.toggle('dsn-sin-reserva', !puede);
    var botones = document.querySelectorAll(BOTONES);
    for (var i = 0; i < botones.length; i++) {
      var b = botones[i];
      b.disabled = !puede;
      b.setAttribute('aria-disabled', String(!puede));
      if (!puede) {
        b.setAttribute('title', 'Primero elige la fecha de tu cita.');
      } else {
        b.removeAttribute('title');
      }
    }
    return puede;
  }

  function armarGuardia() {
    if (aplicarGuardia()) return;
    /* El bloque de una app puede montarse tarde. Se vigila el DOM hasta que
       aparezca, y entonces la guardia se desarma sola. */
    if (!window.MutationObserver) return;
    var obs = new MutationObserver(function () {
      if (aplicarGuardia()) obs.disconnect();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 15000);
  }

  /* ------------------------------------------------------------------ arranque */

  function iniciar() {
    if (supportsVT && !reduced) {
      if (document.querySelector('.feature-product-media')) marcarHeroDeFicha();
      else armarBisagraEnGaleria();
    }
    armarBarra();
    if (document.querySelector('.feature-product-media')) armarGuardia();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
